export default __webpack_public_path__ + "static/aaron-bitmoji-a4eb8d14808112cb9c54c3cd60d21baf.png";